import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Grid2 } from "@mui/material";
import axios from "axios";
import { XMLParser } from "fast-xml-parser";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

let envs = ["Live", "Staging"];
let regions = ["ne", "cat", "phx"];
let series = [];

function FacebookCatalogAds(mode) {
	const [focusEnv, setFocusEnv] = React.useState();
	const [focusRegion, setFocusRegion] = React.useState();
	const [focusSeries, setFocusSeries] = React.useState();
	const [serieAPI, setSeriesAPI] = React.useState([]);
	const [regionJSON, setRegionJSON] = React.useState([]);
	const [xmlVersion, setXmlVersion] = React.useState([]);

	React.useEffect(() => {
		if (focusRegion) {
			loadSeriesAPI();
		}
	}, [focusRegion]);
	// React.useEffect(() => {
	// 	console.log("regionJSON updated");
	// 	console.log(regionJSON);
	// 	if (focusSeries) {
	// 		console.log("running offer data");
	// 		getOfferData();
	// 	}
	// }, [regionJSON]);

	React.useEffect(() => {
		console.log("----- ", focusEnv, focusRegion, focusSeries);
		if ((focusEnv, focusRegion, focusSeries)) {
			loadFBCatalogAdsXML(focusEnv, focusRegion, focusSeries);
		}
	}, [focusEnv, focusRegion, focusSeries]);
	async function getOfferData(json) {
		console.log("getOfferData");
		// console.log(json.listings);
		// console.log(json.listings.listing.length);

		for (let i = 0; i < json.listings.listing.length; i++) {
			// console.log(json.listings.listing[i].model, focusSeries);
			// console.log(json.listings.listing[i].model == focusSeries);
			// console.log("jason");
			document.getElementById("ads").innerHTML = "";
			if (json.listings.listing[i].model == focusSeries) {
				// console.log("jason2");
				//clear all tags in ads
				console.log(json.listings.listing[i].model, focusSeries);

				//build images
				console.log(json.listings.listing[i].image.length);

				for (var u = 0; u < json.listings.listing[i].image.length; u++) {
					//loadImages(json.listings.listing[i]);

					console.log(json.listings.listing[i].image[u].url);
					var image = document.createElement("img");
					var adDiv = document.createElement("div");
					var adA = document.createElement("a");
					adA.href = json.listings.listing[i].url;
					adA.target = "_blank";
					adDiv.appendChild(adA);
					adDiv.classList.add("fbCatAdDiv");

					image.src = json.listings.listing[i].image[u].url;
					image.classList.add("fbCatImg");
					document.getElementById("ads").appendChild(adDiv);
					adA.appendChild(image);
				}
				//if fbCatMetaDiv exists already remove it
				if (document.getElementById("fbCatMetaDiv")) {
					document.getElementById("fbCatMetaDiv").remove();
				}

				var metaDiv = document.createElement("div");

				metaDiv.id = "fbCatMetaDiv";
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].title,
					"Title"
				);

				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].offer_description,
					"Offer Description"
				);
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].vehicle_offer_id,
					"Vehicle Offer ID"
				);
				metaDiv.innerHTML += datacombine(json.listings.listing[i].year, "Year");
				metaDiv.innerHTML += datacombine(json.listings.listing[i].make, "Make");
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].model,
					"Model"
				);

				// metaDiv.innerHTML += datacombine(
				// 	json.listings.listing[i].offer_type,
				// 	"Offer Type"
				// );
				console.log(
					"json.listings.listing[i].url",
					json.listings.listing[i].url
				);
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].url,
					"Clickthrough"
				);
				console.log(json.listings.listing[i].amount_percentage);
				if (json.listings.listing[i].offer_type == "finance") {
					metaDiv.innerHTML += datacombine(
						json.listings.listing[i].amount_percentage,
						"Amount Percentage"
					);
					metaDiv.innerHTML += datacombine(
						json.listings.listing[i].term_length,
						"Term Length"
					);
				} else if (json.listings.listing[i].offer_type == "lease") {
					metaDiv.innerHTML += datacombine(
						json.listings.listing[i].trim,
						"Trim"
					);
					metaDiv.innerHTML += datacombine(
						json.listings.listing[i].amount_price,
						"Amount Price"
					);
					metaDiv.innerHTML += datacombine(
						json.listings.listing[i].amount_qualifier,
						"Amount Qualifier"
					);
					metaDiv.innerHTML += datacombine(
						json.listings.listing[i].term_length,
						"Term Length"
					);
					metaDiv.innerHTML += datacombine(
						json.listings.listing[i].downpayment,
						"Downpayment"
					);
					metaDiv.innerHTML += datacombine(
						json.listings.listing[i].downpayment_qualifier,
						"Downpayment Qualifier"
					);
				}
				metaDiv.innerHTML += datacombine(
					json.listings.listing[i].offer_disclaimer,
					"Disclaimer"
				);

				var dmaHTML = "";
				console.log("xmlVersion", xmlVersion);
				if (xmlVersion === "Comscore") {
					dmaHTML += datacombine(
						json.listings.listing[i].comscore_market_codes,
						"Comscore Marketing Codes"
					);
				} else {
					dmaHTML = `<span><b>DMA Codes:</b> `;
					for (var d = 0; d < json.listings.listing[i].dma_codes.length; d++) {
						dmaHTML += datacombine(json.listings.listing[i].dma_codes, "");
					}
				}
				dmaHTML += "</span>";
				metaDiv.innerHTML += dmaHTML;
				document.getElementById("ads").append(metaDiv);
				return;
			}
			document.getElementById("ads").innerHTML =
				"<h1>Sorry, no data found</h1>";
		}
	}
	function datacombine(data, label) {
		var html = "";

		if (data || data == 0) {
			// if data is an array
			if (Array.isArray(data)) {
				for (var i = 0; i < data.length; i++) {
					html += `<span><b>${label}:</b> ${data[i]}</span>`;
				}
			} else {
				html = `<span><b>${label}:</b> ${data}</span>`;
			}
		} else {
			html = `<span class="fbdataerror"><b>${label}:</b> ${data} is missing</span>`;
		}
		return html;
	}
	async function loadSeriesAPI() {
		const response = await fetch(
			`https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/seriesapi/full/${focusRegion}/seriesapi.json`
		);
		const data = await response.json();
		// 	{
		// 	"seriesname": "Venza",
		// 	"ToyotaAPIName": "venza",
		// 	"modelyear": "2024",
		// 	"grade": "limited",
		// 	"color": "1k9",
		// 	"redirected": "RAV4",
		// 	"status": "paused",
		// 	"group": ["suv", "electrified"]
		// }
		// filter out the status paused
		const filteredData = data.filter((item) => item.status !== "paused");

		setSeriesAPI(filteredData);
		console.log(filteredData);
	}
	async function loadFBCatalogAdsXML(focusEnv, focusRegion, focusSeries) {
		var xml = "";
		if (focusEnv === "Live") {
			await getLiveXML(focusRegion);
		} else if (focusEnv === "Staging") {
			await getStagingXML(focusRegion);
		}
	}

	async function getLiveXML(region) {
		console.log("getLiveXML");
		let filename = "";
		//fetch xml files at https://xmlconverter.datcdn.com/phx_facebook_nf_2.xml
		// if (region === "ne") {
		var xmlVersionMode = "";
		if (xmlVersion === "Comscore") {
			xmlVersionMode = "_Comscore";
		}
		filename = `https://dat-sync.com/assets/se/social/facebook/facebook_automated_catalog_ads/metaInstaCatalog/catalog-xml/${region}${xmlVersionMode}.xml`;
		// } else if (region === "cat") {
		// filename = `https://xmlconverter.datcdn.com/${region}_facebook_nf_2.xml`;
		// }
		fetch(filename)
			.then((response) => response.text())
			.then((data) => {
				const parser = new XMLParser();
				const json = parser.parse(data);
				setRegionJSON(json);
				console.log(json);
				getOfferData(json);
			})
			.catch((error) => {
				console.error("Error fetching the XML file:", error);
			});
	}
	async function getStagingXML(region) {
		console.log("getStagingXML");
		//fetch xml files at https://xmlconverter.datcdn.com/phx_facebook_nf_2.xml
		fetch(
			`https://dat-sync.com/assets/se/social/facebook/facebook_automated_catalog_ads/catalog-xml/${region}.xml`
		)
			.then((response) => response.text())
			.then((data) => {
				const parser = new XMLParser();
				const json = parser.parse(data);
				setRegionJSON(json);
				console.log(json);
				getOfferData(json);
			})
			.catch((error) => {
				console.error("Error fetching the XML file:", error);
			});
	}
	return (
		<div id="htmlPage">
			<h1>Facebook Catalog Ads</h1>
			<Grid2 container spacing={2} direction="column">
				<FormControl sx={{ m: 1, width: 300 }}>
					<InputLabel id="env-select-label">Environment</InputLabel>
					<Select
						labelId="env-select-label"
						id="env-select"
						input={<OutlinedInput label="Environment" />}
						MenuProps={MenuProps}
						value={focusEnv ? focusEnv : ""}
						onChange={(e) => setFocusEnv(e.target.value)}
					>
						{envs.map((env) => (
							<MenuItem key={env} value={env}>
								<ListItemText primary={env} />
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormControl sx={{ m: 1, width: 300 }}>
					<InputLabel id="region-select-label">Region</InputLabel>
					<Select
						labelId="region-select-label"
						id="region-select"
						value={focusRegion ? focusRegion : ""}
						onChange={(e) => setFocusRegion(e.target.value)}
						input={<OutlinedInput label="Region" />}
						MenuProps={MenuProps}
					>
						{regions.map((region) => (
							<MenuItem key={region} value={region}>
								<ListItemText primary={region} />
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormControl sx={{ m: 1, width: 300 }}>
					<InputLabel id="xml-version-label">XML Version</InputLabel>
					<Select
						labelId="xml-version-label"
						id="xml-version-select"
						value={xmlVersion ? xmlVersion : ""}
						onChange={(e) => setXmlVersion(e.target.value)}
						input={<OutlinedInput label="XML Version" />}
						MenuProps={MenuProps}
					>
						<MenuItem key={"Original"} value={"Original"}>
							<ListItemText primary={"Original"} />
						</MenuItem>
						<MenuItem key={"Comscore"} value={"Comscore"}>
							<ListItemText primary={"Comscore"} />
						</MenuItem>
					</Select>
				</FormControl>
				<FormControl sx={{ m: 1, width: 300 }}>
					<InputLabel id="series-select-label">Series</InputLabel>
					<Select
						labelId="series-select-label"
						id="series-select"
						value={focusSeries ? focusSeries : ""}
						onChange={(e) => setFocusSeries(e.target.value)}
						input={<OutlinedInput label="Series" />}
						MenuProps={MenuProps}
					>
						{serieAPI.map((serie) => (
							<MenuItem key={serie.seriesname} value={serie.seriesname}>
								<ListItemText primary={serie.seriesname} />
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid2>
			<Grid2 container spacing={2} id="ads"></Grid2>
		</div>
	);
}

export default FacebookCatalogAds;
